


















import { Component, Vue, Emit } from "vue-property-decorator";

import Button from "@/components/Button.vue";
import Card from "@/components/Card.vue";
import Select from "@/components/Select.vue";

@Component({
  components: {
    Card,
    Button,
    Select,
  },
})
export default class Randomizer extends Vue {
  name = "RandomList"
  items: Array<any> = []
  axios: any
  sortOptions: Array<string>
  selected: string

  data() {
    return {
      items: [],
      sortOptions: [{
        id: "1",
        label: "A-Z",
      }, {
        id: "2",
        label: "Z-A",
      }],
      selected: "",
    }
  }
  /* Display random items when component is loaded */
  created() {
    /* Requests to get random items*/
    const requestRandom = "/random.php";
    for (let i=0; i < 10; i++) {
      this.axios
        .get(requestRandom)
        .then(response => {
          this.items.push(response.data.meals[0])
        });
    }
  }
  /* Function to sort random displayed recipes */
  getSort(e) {
    this.selected = e.target.value;
    if (this.selected === "1" ) {
      this.items.sort((a, b) => {
        return (a.strMeal < b.strMeal) ? -1 : (a.strMeal > b.strMeal) ? 1 : 0;
      })
    }
    if (this.selected === "2") {
      this.items.sort((a, b) => {
        return (a.strMeal < b.strMeal) ? 1 : (a.strMeal > b.strMeal) ? -1 : 0;
      })
    }
  }
}

